import React, { Component } from 'react';
import './Car.style.scss';
import ic from 'assets/icons/pay.svg';
import { get } from 'lodash';
import { nFormatter } from '../../../../utils';

export default class Car extends Component {
  render() {
    const incaap = get(this.props.data, 'in_icaap', []);
    const car = incaap.find((item) => item.no === '6.1');
    return (
      <div className='car-container'>
        <h1 className='title'>
          <img src={ic} alt='' style={{ marginRight: 8 }} />
          CAR (*)
        </h1>
        <div>
          {/* <span className='price'>{nFormatter((car && car.t0_bau) || 0)}%</span> */}
          <span className='price'>{nFormatter(9.83)}%</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/Car/Car.js